// The phone frame's height — THE KEYBOARD FIX (operator, 19 Sept 2026: "TG
// mini app: its screen gets distorted when I open the keyboard to type").
//
// What went wrong: the app was a document that scrolled — a min-height-100vh
// column, the bottom bar position:fixed. When the keyboard came up the web
// view either shrank (Android, newer Telegram iOS) — 100vh shrank with it,
// the fixed bar rode up over the field being typed in, the page jumped — or
// the keyboard covered the bottom and the web view panned the whole document
// up to reveal the field, dragging the bar and the header with it and
// leaving a blank band when the keyboard closed.
//
// The fix, in one place: the app is a box exactly as tall as what is
// VISIBLE (window.visualViewport — the browser's own reading, which shrinks
// by the keyboard on both platforms, whether the web view resizes or the
// keyboard overlays it), the document never scrolls (styles.css, below lg),
// and <main> scrolls inside the box. So typing only makes the app shorter;
// nothing rides up, nothing pans. --app-height is written on <html> and
// ConsoleShell sizes the phone column by it; Telegram's own viewportChanged
// re-reads it too. When the field is off the shortened screen the app's own
// scroller brings it in.
//
// Outside Telegram (the web login) the same rule holds — a browser's URL bar
// is just another thing that resizes the visible area.

import { tg } from './telegram';

export function bootViewport(): void {
  const root = document.documentElement;
  const vv = window.visualViewport;

  const apply = () => {
    const h = vv ? vv.height : window.innerHeight;
    root.style.setProperty('--app-height', `${Math.round(h)}px`);
    // A pan of the document to show the focused field is undone — the
    // app's scroller does that itself, and a panned page is the
    // "distorted" screen: the bar mid-screen and the header cut off.
    if (window.scrollY > 0 || (vv && vv.offsetTop > 0)) window.scrollTo(0, 0);
    const el = document.activeElement;
    if (el instanceof HTMLElement && /^(INPUT|TEXTAREA|SELECT)$/.test(el.tagName)) {
      el.scrollIntoView({ block: 'nearest' });
    }
  };

  apply();
  vv?.addEventListener('resize', apply);
  vv?.addEventListener('scroll', apply);
  window.addEventListener('resize', apply);
  tg()?.onEvent('viewportChanged', apply);
}
